(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('billet-cart-state')) customElements.define('billet-cart-state', class extends HTMLElement {
  connectedCallback() {
    const count = this.closest('cart-drawer')?.querySelector('.bl-cart-count');
    if (count) count.textContent = this.dataset.count;
  }
});
if (!customElements.get('billet-cart-extra')) customElements.define('billet-cart-extra', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.addEventListener('change', event => {
      event.stopPropagation();
      const option = event.target.selectedOptions?.[0];
      if (!option) return;
      this.querySelector('.bl-extra-price').textContent = option.dataset.price;
      const image = this.querySelector('img');
      if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
      this.querySelector('[name="quantity"]').value = option.dataset.quantity || '1';
    });
    this.querySelector('form').addEventListener('submit', async event => {
      event.preventDefault();
      event.stopPropagation();
      if (this.busy) return;
      this.busy = true;
      const form = event.currentTarget;
      const button = form.querySelector('button');
      const error = this.querySelector('.bl-extra-error');
      const drawer = this.closest('cart-drawer');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      error.hidden = true;
      let added = false;
      try {
        const data = new FormData(form);
        data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
        data.append('sections_url', window.location.pathname);
        drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        added = true;
        if (!result.sections?.['cart-drawer']) { window.location.assign(window.Shopify.routes.root + 'cart'); return; }
        drawer.classList.remove('is-empty');
        drawer.renderContents(result);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'billet-cart-extra', productVariantId: data.get('id'), cartData: result });
      } catch (failure) {
        if (added) { window.location.assign(window.Shopify.routes.root + 'cart'); return; }
        error.textContent = failure.message || this.dataset.error;
        error.hidden = false;
      } finally {
        this.busy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
